import Select from "react-select";
import { useTranslateKey } from "../translation/useTranslateKey";

const CustomSelect = ({
  options = [],
  value,
  onChange,
  placeholder,
  isDisabled = false,
  className = "",
}) => {
  const t = useTranslateKey();
  // Use translated default if no placeholder is provided
  const translatedPlaceholder = placeholder || t("selectOption");

  return (
    <Select
      className={`w-full ${className}`}
      classNamePrefix="react-select"
      options={options}
      value={options.find((option) => option.value === value) || null}
      onChange={(selectedOption) => onChange(selectedOption?.value || "")}
      isDisabled={isDisabled}
      isSearchable={false}
      placeholder={translatedPlaceholder}
      styles={{
        control: (base, state) => ({
          ...base,
          opacity: state.isDisabled ? 0.6 : 1,
          backgroundColor: state.isDisabled
            ? "rgba(255, 255, 255, 0.4)"
            : state.isFocused
            ? "rgba(255, 255, 255, 0.15)"
            : "#11132F",
          border: state.isDisabled
            ? "1px solid #555"
            : state.isFocused
            ? "1px solid #f9c835"
            : "1px solid #332d7e",
          borderRadius: 8,
          height: "53px",
          paddingLeft: "16px",
          paddingRight: "40px",
          display: "flex",
          alignItems: "center",
          boxShadow: "none",
          transition: "all 0.3s ease",
          color: "#fff",
          "&:hover": {
            backgroundColor: state.isFocused
              ? "rgba(255, 255, 255, 0.15)"
              : "rgba(0, 0, 0, 0.3)",
            borderColor: state.isFocused
              ? "#f9c835"
              : "rgba(255, 255, 255, 0.2)",
          },
        }),
        dropdownIndicator: (base) => ({
          ...base,
          color: "#aaa",
          position: "absolute",
          right: "12px",
          padding: 0,
        }),
        indicatorSeparator: () => ({
          display: "none",
        }),
        menu: (base) => ({
          ...base,
          backgroundColor: "#11132F",
          border: "1px solid #f9c835",
          borderRadius: 8,
          marginTop: 4,
          color: "white",
          zIndex: 9999,
          overflowX: "hidden",
        }),
        menuList: (base) => ({
          ...base,
          overflowX: "hidden",
          overflowY: "visible",
          maxHeight: "none",
          paddingRight: 0,
          scrollbarColor: "#007ACC transparent", // scroller color
          scrollbarWidth: "thin",
        }),
        option: (base, state) => ({
          ...base,
          whiteSpace: "nowrap",
          overflowX: "hidden",
          textOverflow: "ellipsis",
          cursor: "pointer",
          color: "#fff",
          backgroundColor: state.isFocused ? "#007ACC" : "#11132f",
          textAlign: "left", // text left
          paddingLeft: "12px",
          ":active": {
            backgroundColor: "#007ACC",
          },
        }),
        singleValue: (provided, state) => ({
          ...provided,
          opacity: state.isDisabled ? 0.5 : 1,
          transition: "opacity 300ms",
          color: "#fff",
        }),
        placeholder: (base, state) => ({
          ...base,
          marginLeft: 0,
          paddingLeft: 0,
          color: "#fff",
        }),
        valueContainer: (base) => ({
          ...base,
          paddingLeft: "0px",
          justifyContent: "flex-start",
        }),
      }}
    />
  );
};

export default CustomSelect;
